import React, { useState, useEffect } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { ListDialog } from "../shared/listDialog";
import { nomService } from '../../services/api/nom.service';
import { preauthorizationService } from '../../services/api/preauthorization.service';
import { alertService } from '../../services/helpers/alert.service';
import { utils } from "../../services/helpers/utils";


export const PreauthorizationDiagnostics = (props) => {
    const _newRow = {
        idDiagnostic: 0,
        idPreautorizare: props.id ?? 0,
    }
    const [list, setList] = useState([]);
    const [defaults, setDefaults] = useState([])
    const [dropdown, setDropdown] = useState([])
    const [showDialog, setShowDialog] = useState(false);
    const [clickedIndex, setClickedIndex] = useState(null);
    const [newRow, setNewRow] = useState(_newRow);
    const [searchTerm, setSearchTerm] = useState("");
    const [virtual, setVirtual] = useState({
        skip: 0,
        take: 10,
        pageSize: 10
    });

    useEffect(() => {

        if (props && props.id) {
            preauthorizationService.getDiagnostics({ preauthorizationId: props.id })
                .then(response => {
                    if (response) {
                        setList(response);
                        props.setDiagnostice(response);
                    }
                });
        }
    }, [props.refresh]);

    useEffect(() => {
        nomService.getDiagnostics()
            .then(response => {
                if (response) {
                    // Setez dropdownul
                    setDropdown(response);

                    // Setez defaulturile
                    if (list.length > 0 && response.length > 0) {
                        var d = [];
                        for (var item in list) {
                            var el = utils.findObjectById(response, list[item].idDiagnostic)
                            d.push(el);
                        }
                        setDefaults(d);
                    }
                }
            });
    }, [list]);

    const updateLists = ( list ) => {
        setList(list);
        props.setDiagnostice(list);
        if (props.setIsModified) {
            props.setIsModified( true );
        }
    }

    const handleAdd = () => {
        const updatedList = [...list, newRow];
        updateLists(updatedList);
        setNewRow(_newRow);
    };

    const handleChange = (event, index, field) => {
        const updatedList = [...list];
        var v = event.target.value;
        updatedList[index][field] = v.id;
        updateLists(updatedList);
        setSearchTerm("");
    };

    const handleDelete = (index) => {
        alertService.confirm("Atentie", "Esti sigur ca vrei sa stergi aceast diagnostic?"
            , () => {
                const updatedList = [...list];
                updatedList.splice(index, 1);
                updateLists(updatedList);
            }
            , () => { return; }
        );
    };

    const handleDialog = () => {
        setShowDialog(!showDialog);
    }

    const handleClick = (item) => {
        setClickedIndex(item);
        setShowDialog(true);
    }

    const handleReturn = (item) => {

        let newList = [...list];
        newList[clickedIndex].idDiagnostic = dropdown[item].id;
        updateLists(newList);
        
    }

    const handleFilterChange = (e) => {
        setSearchTerm(e.filter.value);
        setVirtual((prevState) => ({
            ...prevState,
            skip: 0
        }));
    };

    const filtred = searchTerm
        ? dropdown.filter((item) =>
            item.text.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : dropdown;





    return (
        <>
        <div className="pt20">
            <fieldset>
                <legend className="pb5">Diagnostice <span className="red">*</span></legend>
                <table className="tbl tbladd mt5" data-name="lista_diagnostice" width="100%">
                    <thead>
                        <tr>
                            <th>Diagnostic</th>
                            <th width="50">Editeaza</th>
                            <th width="50">Sterge</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <DropDownList
                                        data={filtred}
                                        virtual={virtual}
                                        onVirtualPageChange={(e) => {
                                            setVirtual({
                                                skip: e.page.skip,
                                                take: e.page.take
                                            });
                                        }}
                                        textField="text"
                                        dataItemKey="id"
                                        value={defaults[index]}
                                        name="idDiagnostic"
                                        className="text w550 fl"
                                        onChange={(event) =>
                                            handleChange(event, index, "idDiagnostic")
                                        }

                                        disabled={props.finalizare == 1}
                                        onFilterChange={handleFilterChange}
                                        filterable
                                    />
                                </td>
                                {!props.finalizare && (
                                <>
                                        <td className="center"
                                            data-name="diagnostic_edit"
                                            onClick={() => handleClick(index)}
                                        >
                                            
                                            <span className="icon modifica center"></span>
                                        </td>
                                        <td className="center"
                                            onClick={() => handleDelete(index) }
                                            data-name="diagnostic_del">
                                            <span className="icon sterge center"></span>
                                        </td>
                                </>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>

                {!props.finalizare && (
                    <button data-name="adauga_diagnostic"
                        className="btn"
                        onClick= {handleAdd}
                    >Adauga diagnostic</button>
                )}
            </fieldset>
        </div>

        
            {
        showDialog && < ListDialog title="Investigatii"
            data={dropdown}
            handleDialog={handleDialog}
            handleReturn={handleReturn} />
    }
    </>
    );
}
